"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPercent = formatPercent;
var _getFormattedNumber = require("../internals/getFormattedNumber");
var _makeSpacesNonBreakable = require("../internals/makeSpacesNonBreakable");
var _replacePattern = require("../internals/replacePattern");
var _formatNumber = require("./formatNumber");
/**
 * Returns parameter `value` formatted as the percentage.
 *
 * The `value` is formatted in the runtime culture in case:
 * - the {@link culture} setting is not provided,
 * - the percent formatting rules or percent pattern are not available in the {@link culture} setting.
 * @see {@link formatNumber} for more information.
 *
 * @param value Numeric value to format
 * @param culture Culture settings containing formatting rules
 * @param options Additional formatting options
 * @returns `value` formatted as the percentage
 * @example
  // basic usage
  import { formatPercent, useCulture } from '@ori/culture';
  const { culture } = useCulture();
  const formattedPercent = formatPercent(1234.567, culture);

  // specify number of decimals to display
  formatPercent(1234.567, culture, { decimals: Decimals.One })
 */
function formatPercent(value, culture, options) {
  const {
    percentFormat
  } = culture ?? {};
  const percentPattern = value < 0 ? percentFormat?.negativePattern : percentFormat?.positivePattern;
  if (!percentFormat || !percentPattern) {
    // it is preferred by the business to display the value formatted in the runtime culture than no value at all
    return `${(0, _formatNumber.formatNumber)(value, culture)}%`;
  }
  return (0, _makeSpacesNonBreakable.makeSpacesNonBreakable)((0, _replacePattern.replacePattern)(percentPattern, {
    n: (0, _getFormattedNumber.getFormattedNumber)(value, options?.decimals ?? percentFormat.decimals, percentFormat.decimalSeparator, percentFormat.groupSizes, percentFormat.groupSeparator
    // we can't use the negative pattern here because percents have different positive and negative formatting pattern than decimals
    ),
    '%': percentFormat.symbol ?? '%'
  }));
}
//# sourceMappingURL=formatPercent.js.map